export default __webpack_public_path__ + "images/ca-d348137a99e6d528c5b7ffec1e05488a.svg";